module.exports = __webpack_public_path__ + "static/img/henyuan.0cf4f90b.png";